<template>
  <div class="surrounding-resources">
    <div class="title-box">
      <div class="txt-box"></div>
      <img :src="newClose" alt="" @click="closeModel" />
      <div class="txt">{{ surroundingResourcesObj.text }}</div>
    </div>
    <div class="surrounding-content">
      <div class="quantity">数量：{{ pageObj.totalCount }}</div>
      <div class="table-box">
        <div class="table-header flex-space-between" v-if="headerConfig">
          <span
            v-for="(header, index) in headerConfig.headers"
            :key="index"
            :style="{ width: header.width }"
            >{{ header.label }}</span
          >
        </div>
        <div class="table-content">
          <ul class="scroll-box" v-if="headerConfig">
            <li
              class="flex-space-between"
              v-for="(item, index) in listArr"
              :key="index"
            >
              <span
                v-for="(header, hIndex) in headerConfig.headers"
                :key="hIndex"
                :style="{ width: header.width }"
                :title="item[header.key]"
                class="text-hidden"
                :class="{
                  positioning: hIndex === headerConfig.headers.length - 1,
                }"
                @click="
                  setPositioning(
                    item,
                    hIndex === headerConfig.headers.length - 1
                  )
                "
              >
                {{
                  item[header.key] ||
                  (item[header.key] == '0' ? "0" : "") ||
                  (hIndex === headerConfig.headers.length - 1
                    ? "定位"
                    : hIndex === 0
                    ? index + 1
                    : "")
                }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newClose from "@/assets/img/newClose.png";
import { tubiaoInitLeft } from "@/assets/js/url.js";

export default {
  name: "SurroundingResources",
  props: ["surroundingResourcesShowModal", "surroundingResourcesObj"],
  data() {
    return {
      newClose: newClose,
      listArr: [],
      pageObj: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
      },
      loadingMore: false, // 控制加载更多状态
    };
  },
  computed: {
    headerConfig() {
      const configs = {
        1: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "20%" },
            { label: "类别", key: "categoryTypeName", width: "10%" },
            { label: "主要成分", key: "important", width: "10%" },
            { label: "负责人", key: "personLiable", width: "10%" },
            { label: "联系方式", key: "phone", width: "15%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        2: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "30%" },
            { label: "类型", key: "gasStationName", width: "10%" },
            { label: "负责人", key: "chargePerson", width: "10%" },
            { label: "联系方式", key: "phone", width: "15%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        3: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "30%" },
            { label: "类型", key: "waterSourceTypeName", width: "10%" },
            { label: "负责人", key: "chargePerson", width: "10%" },
            { label: "联系方式", key: "phone", width: "15%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        4: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "35%" },
            { label: "出入口形式", key: "modality", width: "30%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        5: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "25%" },
            { label: "级别", key: "refugeLevelName", width: "15%" },
            { label: "类型", key: "refugeName", width: "15%" },
            { label: "容纳人数", key: "galleryful", width: "10%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        6: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "45%" },
            { label: "限高(m）", key: "heightLimit", width: "20%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
        7: {
          headers: [
            { label: "序号", key: "", width: "10%" },
            { label: "名称", key: "name", width: "10%" },
            { label: "地址", key: "address", width: "25%" },
            { label: "值班电话", key: "dutyPhone", width: "15%" },
            { label: "负责人", key: "chargePerson", width: "10%" },
            { label: "联系方式", key: "phone", width: "15%" },
            { label: "操作", key: "", width: "10%" },
          ],
        },
      };
      return configs[this.surroundingResourcesObj.type];
    },
  },
  watch: {
    surroundingResourcesShowModal(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.getListData(this.surroundingResourcesObj);
        });
      }
    },
  },
  methods: {
    async getListData(activeItem) {
      if (this.loadingMore) return; // 防止重复加载
      this.loadingMore = true;
      this.listArr = [];

      try {
        const data = {
          type: "get",
          url: "/mcbw/dep_stats/list_resources_info",
          obj: {
            appCode: "runWatchScreen",
            type: activeItem.type,
            currentPage: this.pageObj.currentPage,
            pageSize: this.pageObj.pageSize,
            orgId: JSON.parse(window.localStorage.getItem("loginData")).orgId,
          },
        };

        const res = await this.$Axios(data);
        if (res.data.success) {
          this.listArr = [...this.listArr, ...res.data.data];
          this.pageObj.totalCount = res.data.totalCount;

          if (this.listArr.length < this.pageObj.totalCount) {
            setTimeout(() => {
              this.$nextTick(() => {
                $JQ(".table-content").mCustomScrollbar({
                  callbacks: {
                    onTotalScroll: () => this.loadMore(),
                  },
                });
              });
            }, 500);
          }
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      } finally {
        this.loadingMore = false;
      }
    },
    loadMore() {
      if (this.listArr.length < this.pageObj.totalCount && !this.loadingMore) {
        this.pageObj.currentPage += 1;
        this.getListData(this.surroundingResourcesObj);
      }
    },
    closeModel() {
      this.$emit("up-data-fn", false);
    },
    setPositioning(activeItem, bol) {
      if (bol) {
        this.$emit(
          "get-this-position",
          [
            Number(activeItem.position.split(",")[0]),
            Number(activeItem.position.split(",")[1]),
          ],
          2
        );
        console.log(activeItem.position, 2);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.surrounding-resources {
  width: 600px;
  height: 300px;
  background: #06122c url("../assets/img/maskBg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -280px;
  margin-top: -250px;
  border-radius: 5px;
  box-sizing: border-box;
  z-index: 999;
  .title-box {
    padding: 12px 17px;
    overflow: hidden;
    .txt-box {
      width: 90%;
      height: 35px;
      float: left;
      background: linear-gradient(
        90deg,
        #74d9ff 0%,
        rgba(116, 217, 255, 0) 48%
      );
      opacity: 0.6;
    }
    .txt {
      position: absolute;
      left: 30px;
      top: 7px;
      color: #74d9ff;
    }
    img {
      width: 16px;
      height: 16px;
      float: right;
      cursor: pointer;
    }
  }
  .surrounding-content {
    padding: 0 10px;
    .quantity {
      text-align: right;
      color: #74d9ff;
    }
    .table-box {
      .table-header {
        background: rgba(116, 217, 255, 0.25);
        color: #74d9ff;
        line-height: 35px;
        padding: 0 10px;
      }
      .table-content {
        color: #fff;
        height: 192px;
        overflow-y: scroll;
        ul {
          li {
            padding: 10px 10px;
            line-height: 25px;
            font-size: 12px;
            &:nth-child(even) {
              background: rgba(116, 217, 255, 0.25);
            }
            .positioning {
              background-color: #00b578;
              border-radius: 10px;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surrounding-resources.vue